export enum CertificateTypeEnum {
  INNER_OPENSSL = 'INNER_OPENSSL',
  CRYPTOPRO = 'CRYPTOPRO',
}
